import { config } from '../../../config';
import { HttpClientInstance } from '../../apiStore/types/HttpClientInstance';
import { LoanDocumentType } from '../types/LoanDocumentType';
import { LoanSignedUrlResponseType } from '../types/LoanSignedUrlResponseType';
import { reportURLError } from './reportURLError';

export const getSignedUrl =
  ({
    getFileName,
    portalHttpRequest,
  }: {
    getFileName: (file: File) => string;
    portalHttpRequest: HttpClientInstance;
  }) =>
  (document: LoanDocumentType): Promise<LoanSignedUrlResponseType> => {
    // the API builds the whole key (CP-7097), so no count or extension
    const originalFileName = getFileName(document.file);

    return portalHttpRequest
      .post<LoanSignedUrlResponseType>(
        `/2.0/documents/loan-signed-url`,
        {
          contentType: document.file.type,
          documentType: document.type,
          originalFileName,
        },
        config.loanDocuments.signedUrlConfig,
      )
      .catch(reportURLError(document));
  };
